import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import tabletParque from "../../assets/tests/scn5/tablet-parque.jpg";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import NextButton from "../../components/NextButton";

function Scenario5({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = getScenarioNumByPath(location.pathname);

  // 👇 estado para manejar qué slide está activo
  const [currentIndex, setCurrentIndex] = useState(0);

  const texts = [
    "El paciente ha recibido tratamiento con apalutamida por 20 meses",
    "El episodio adverso que ha presentado es fatiga de grado 1",
    "No ha requerido ajuste de dosis",
	  "APE nadir: 0,06"
  ];

  return (
    <div className="h-100">
      <div className="container-fluid h-100 bgCircleGreen">
        <div className="row h-100">
          {/* Columna izquierda con retroalimentación */}
          <div
            className="col-md-5 d-flex justify-content-start align-items-center ps-5"
            style={{ marginBottom: "2vh" }}
          >
            <div className="d-flex flex-column align-items-start w-100">
              <h3 className="txtTitulos green bold w-100" style={{ backgroundColor: "#FFFFFFAA", borderRadius: "10px"}}>
                Seguimiento
              </h3>
              <div className="row">
                <div className="col-6">
                  <p
                    className="position-relative mt-3"
                    style={{
                      padding: "20px",
                      lineHeight: "1.6",
                      border: "1px solid #53CE76",
                      borderRadius: "8px",
                      overflow: "hidden",
                      height: "180px",
                      width: "100%",
                    }}
                  >
                    <div
                      className="txtTexto1"
                      dangerouslySetInnerHTML={{ __html: texts[0] }}
                    />
                  </p>
                </div>
                <div className="col-6">
                  <p
                    className="position-relative mt-3"
                    style={{
                      padding: "20px",
                      lineHeight: "1.6",
                      border: "1px solid #53CE76",
                      borderRadius: "8px",
                      overflow: "hidden",
                      height: "180px",
                      width: "100%",
                    }}
                  >
                    <div
                      className="txtTexto1"
                      dangerouslySetInnerHTML={{ __html: texts[1] }}
                    />
                  </p>
                </div>
                <div className="col-6">
                  <p
                    className="position-relative mt-2"
                    style={{
                      padding: "20px",
                      lineHeight: "1.6",
                      border: "1px solid #53CE76",
                      borderRadius: "8px",
                      overflow: "hidden",
                      height: "180px",
                      width: "100%",
                    }}
                  >
                    <div
                      className="txtTexto1"
                      dangerouslySetInnerHTML={{ __html: texts[2] }}
                    />
                  </p>
                </div>
                <div className="col-6">
                  <p
                    className="position-relative mt-2"
                    style={{
                      padding: "20px",
                      lineHeight: "1.6",
                      border: "1px solid #53CE76",
                      borderRadius: "8px",
                      overflow: "hidden",
                      height: "180px",
                      width: "100%",
                    }}
                  >
                    <div
                      className="txtTexto1"
                      dangerouslySetInnerHTML={{ __html: texts[3] }}
                    />
                  </p>
                </div>
              </div>
							<div className="mt-3 w-100">
								<NextButton
									navigateTo={ROUTES.SCENARIO5_APALUTAMIDA}
									activeScenario={activeScenario}
                  color="green"
								/>
							</div>
            </div>
          </div>

          {/* Columna derecha con imágenes */}
          <div className="col-md-7 d-flex justify-content-center align-items-center mb-5">
            <img
              src={tabletParque}
              className="rounded shadow"
              style={{ maxWidth: "95%", borderRadius: "12px" }}
              alt="Estudio"
            />
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario5);
